// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, number, boolean, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsVoucherGroupIdAppGroupIdResult = objectOf({
  id: string,
  name: string,
  code_snippet: string,
  codes: arrayOf(string),
  unused_codes: number,
  description: string,
  email_address: anyOf(string, nullOrUndefined),
  notify_when_unused_is_less_than: anyOf(number, nullOrUndefined),
  notify_expires_within_in_seconds: anyOf(number, nullOrUndefined),
  expires_at: string,
  is_expired: boolean,
});
